import { filter, find, toNumber } from 'lodash-es'
import { WallRipConfig } from './types'

export const getWallRipConfigMap = (
  guid: string,
  rips: PositionForVertical[],
  defaultCreation: boolean,
): WallRipConfig => {
  const ripsOnElement = filter(rips, rip => rip.wall_guid === guid)

  const existingRipOnStart = !!find(ripsOnElement, rip => toNumber(rip.relative_position) === 0)
  const existingRipOnEnd = !!find(ripsOnElement, rip => toNumber(rip.relative_position) === 1)

  return {
    [guid]: {
      start: defaultCreation || existingRipOnStart,
      startLocked: existingRipOnStart,

      end: defaultCreation || existingRipOnEnd,
      endLocked: existingRipOnEnd,
    },
  }
}
